/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportScheduleUpdateRequest {
    getFixupPrototypeFunction() { return ReportScheduleUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<ReportScheduleUpdateRequest>): ReportScheduleUpdateRequest {
        let obj = Object.assign(new ReportScheduleUpdateRequest(), model);
        ReportScheduleUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportScheduleUpdateRequest>): ReportScheduleUpdateRequest {
        if (!model) return null;
        return ReportScheduleUpdateRequest.newInstance(<ReportScheduleUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportScheduleUpdateRequest) {
        if (!obj) return;

        models.ReportScheduleUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportScheduleUpdateRequest): boolean {
        Object.setPrototypeOf(obj, ReportScheduleUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_time === "string") {
            this.start_time = new Date(<string><any>this.start_time);
        }
        if (this.recurrence) {
            models.ReportScheduleRecurrence.fixupPrototype(this.recurrence);
        }
    }

    /**
     * Name of the schedule; must be unique among the user's schedules
     */
    name: string;

    /**
     * File format the report is delivered in
     */
    export_format: models.ReportScheduleExportFormat;

    /**
     * Email addresses the report is delivered to
     */
    emails: Array<string>;

    /**
     * Date and time of the first run
     */
    start_time: Date;

    /**
     * When the schedule repeats
     */
    recurrence: models.ReportScheduleRecurrence;

}
